import { initializeApp } from "firebase/app";
import { getAuth, signInWithPhoneNumber } from "firebase/auth";
import { getDatabase, onValue, ref } from "firebase/database";
// import "firebase/firebase-firestore";
import { FIREBASE_CONFIG } from "../config/env.config";

const firebaseConfig = FIREBASE_CONFIG;

class Firebase {
  constructor() {
    const app = initializeApp(firebaseConfig);
    this.getAuth = getAuth(app);
    this.getDatabase = getDatabase(app);
    // this.firestore = app.firestore();
  }

  login(username) {
    const appVerifier = window.recaptchaVerifier;

    return signInWithPhoneNumber(
      this.getAuth,
      username,
      appVerifier
    );
  }

  logout() {
    this.getAuth.signOut().then((r) => {
      localStorage.clear()
      sessionStorage.clear()
    });
  }

  addUserInfo(userInfo) {
    if (userInfo) {
      this.firestore
        .doc(`users/${this.getAuth.currentUser.uid}`)
        .set(userInfo)
        .then((r) => console.log(""))
        .catch((e) => console.log(e));
    }
  }

  updateUserInfo(userInfo) {
    if (userInfo) {
      this.firestore
        .doc(`users/${this.getAuth.currentUser.uid}`)
        .update(userInfo)
        .then((r) => console.log(""))
        .catch((e) => console.log(e));
    }
  }

  async getAccessToken() {
    return this.getAuth.currentUser.getIdToken();
  }

  async getUserinfo() {
    const data = await this.firestore
      .doc(`users/${this.getAuth.currentUser.uid}`)
      .get();

    return data.get("userInfo") ? data.get("userInfo") : "User data not found";
  }

  async register(name, email, pass) {
    await this.getAuth
      .createUserWithEmailAndPassword(email, pass)
      .then((d) => console.log(""));
    return this.getAuth.currentUser.updateProfile({
      displayName: name,
    });
  }
}

export default new Firebase();
